// import faker from '@faker-js/faker'

import { faker } from '@faker-js/faker';
import FetchOrders from '../../services/FetchOrders';


export async function fetchDataPurchases(options) {
    
    
    // Simulate some network latency
    
    var data =  await  new Promise( async (resolve , reject) =>{
        
        const resp = await FetchOrders()
        
        const JSON_DATA = await resp.Orders
        // const resp = await fetch(``)
        // const JSON_data = await resp.json()
        // const pagination = JSON_data.pagination
        // const CryptoData = JSON_data.data
        
        // let CoinsArray = []

        // CryptoData.forEach((element , i) => {
            
   
        //     CoinsArray.push(NewCoin(element , i))
           
        // });
        

        resolve(JSON_DATA)
        // const len = 110


        // resolve (range(len).map((d) => {
        //     
        //   return {
        //     ...newPerson(d),
        //   }
        // }))
    })


    return {
      rows: data,
      pageCount: 1,
    }
  }